<template>
  <v-menu bottom left v-model="menuVisible">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon color="primary">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <DeleteDialog :device="device" @close="close" in-menu  @reload="$emit('reload')" />

      <v-list-item @click="resendCode">
        <v-list-item-title>Resend Code</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>  
</template>

<script>
import DeleteDialog from './DeleteDialog'
import { mapActions } from 'vuex'

export default {
  name: 'DevicesActionsMenu',

  props: ['device'],

  components: { DeleteDialog },

  data: () => ({
    menuVisible: false,
  }),

  methods: {
    ...mapActions('devices', ['resend_code']),

    close() {
      this.menuVisible = false
    },

    async resendCode() {
      const { device_id } = this.device

      const result = await this.resend_code({ device_id })
      if (result.ok) {
        this.$router.push({ 
          name: 'profile/wizard/verify',
          params: { device_id },
        })
      } else {
        this.$emit('error', result.error)
      }
    },
  },
}
</script>